import React, { useState } from 'react';
import styled from 'styled-components';
import { Text, Title } from '../../UI/Typography';
import CompanyRegisterForm from '../AuthComponents/CompanyRegisterForm';
import UserRegisterForm from '../../Usermanagement/Usermanagementcomponents/Userregisterform';

const WizardContainer = styled.div`
  width: 100%;
  font-family: ${({ theme }) => theme.typography.fontFamily};
`;

const StepIndicator = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spacing.lg};
  gap: ${({ theme }) => theme.spacing.md};
`;

const Step = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm};
`;

const StepNumber = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: ${({ theme }) => theme.typography.fontWeights.bold};
  font-size: ${({ theme }) => theme.typography.fontSizes.sm};
  background-color: ${({ active, completed, theme }) => {
    if (completed) return theme.colors.success;
    if (active) return theme.colors.primary;
    return theme.colors.border;
  }};
  color: ${({ active, completed, theme }) => {
    if (completed || active) return 'white';
    return theme.colors.text.secondary;
  }};
  transition: all 0.3s ease;
`;

const StepLabel = styled(Text)`
  font-weight: ${({ active, theme }) => 
    active ? theme.typography.fontWeights.semibold : theme.typography.fontWeights.medium
  };
  color: ${({ active, completed, theme }) => {
    if (completed) return theme.colors.success;
    if (active) return theme.colors.primary;
    return theme.colors.text.secondary;
  }};
`;

const StepSeparator = styled.div`
  width: 40px;
  height: 2px;
  background-color: ${({ completed, theme }) => 
    completed ? theme.colors.success : theme.colors.border
  };
  transition: all 0.3s ease;
`;

const WizardContent = styled.div`
  width: 100%;
`;

const RegistrationWizard = ({ onComplete }) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [companyData, setCompanyData] = useState(null);

  const steps = [
    { number: 1, label: 'Company Registration' },
    { number: 2, label: 'Admin User Setup' }
  ];

  const handleCompanyRegistrationSuccess = (result) => {
    console.log('Company registered:', result);
    setCompanyData(result);
    setCurrentStep(2);
  };

  const handleUserRegistrationSuccess = () => {
    console.log('Admin user registered successfully');
    if (onComplete) {
      onComplete({ companyData });
    }
  };

  const renderStepContent = () => {
    switch (currentStep) {
      case 1:
        return (
          <CompanyRegisterForm 
            onSuccessfulSubmit={handleCompanyRegistrationSuccess}
          />
        );
      case 2:
        return (
          <UserRegisterForm 
            onSuccessfulSubmit={handleUserRegistrationSuccess}
            companyData={companyData}
            isAdminSetup={true}
          />
        );
      default:
        return null;
    }
  };

  return (
    <WizardContainer>
      <StepIndicator>
        {steps.map((step, index) => (
          <React.Fragment key={step.number}>
            <Step>
              <StepNumber 
                active={currentStep === step.number}
                completed={currentStep > step.number}
              >
                {currentStep > step.number ? '✓' : step.number}
              </StepNumber>
              <StepLabel 
                size="sm"
                active={currentStep === step.number}
                completed={currentStep > step.number}
              >
                {step.label}
              </StepLabel>
            </Step>
            {index < steps.length - 1 && (
              <StepSeparator completed={currentStep > step.number} />
            )}
          </React.Fragment>
        ))}
      </StepIndicator>

      <WizardContent>
        {renderStepContent()}
      </WizardContent>
    </WizardContainer>
  );
};

export default RegistrationWizard;